import * as React from "react";
import EditFault from "../../Editing/EditFault";
import Table from "../../../components/Table/Table";
import { Dimmer } from "semantic-ui-react";
import { setFaultExtraProperties } from "../../../utils/pdApiUtils";
import { editActions } from "../../../actions/editActions";
import { pdApiActions } from "../../../actions/pdApiActions";
import { mainActions } from "../../../actions/mainActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import _ from "lodash";

/**
 * All the following props are passed from parent component
 */
export type DriveFaultsTableProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  isLoadingFaults: boolean;
  pdApiActions: typeof pdApiActions;
  editActions: typeof editActions;
  mainActions: typeof mainActions;
  subMenuRoute: State.DriveSubmenu;
  toggleModal: () => void;
  columnFilters: Filter[];
  setColumnFilters: (subMenuRoute: State.DriveSubmenu, columnFilter: Filter[]) => void;
};

type DriveFaultsTableState = {
  isModalOpen: boolean;
};

export class DriveFaultsTable extends React.Component<
  DriveFaultsTableProps,
  DriveFaultsTableState
> {
  state = {
    isModalOpen: false
  };

  componentWillUnmount(): void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }

  componentDidMount(): void {
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };

  render(): JSX.Element {
    const { columns, pdApi, mainState, isEditActive, toggleModal, isLoadingFaults } = this.props;
    const { driveFaults } = pdApi;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    let driveFaultRows: Api.AnyFault[] = [];
    let selectedColumns: State.Column[] = [];

    driveFaultRows = driveFaults ? driveFaults : [];
    driveFaultRows = driveFaultRows.map(row => setFaultExtraProperties(row, pdApi));
    selectedColumns = columns["Drive Faults"];
    
    const startingPage = mainState.lastEditedObjectId
      ? (driveFaultRows.findIndex(fault => fault.id === mainState.lastEditedObjectId) / // tslint:disable-line: no-bitwise
          mainState.pageSize) >>
        0
      : 0;
    return (
      <div className="flex-1">
        <div className="flex-1">
          <Table
            startingPage={startingPage}
            rows={driveFaultRows}
            loading={isLoadingFaults}
            loadingText="Fetching drive faults..."
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isFaultSelected}
            pageSize={pageSize}
            handleFilterChange={this.handleFilterChangeDebounced}
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div
              className="edit-view"
              style={{ flex: editSize, width: editSize == 0.3 ? "500px" : "1000px" }}
            >
              <EditFault toggleModal={toggleModal} columns={columns} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }

  /**
   * Returns status if fault has been selected
   * @param {Api.Fault} fault
   * @returns {boolean}
   */
  private isFaultSelected = (fault: Api.AnyFault): boolean => {
    const editedObjectId = this.props.editedObjectId ?? this.props.mainState.lastEditedObjectId;
    if (editedObjectId && fault.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

export default DriveFaultsTable;
